/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from 'react';
import { Grid, Container, IconButton, Typography, Card, CardContent, CardMedia, Chip, Box, Stack } from '@mui/material';
import {Search} from 'lucide-react';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import GridOnIcon from '@mui/icons-material/GridOn';
import ViewListIcon from '@mui/icons-material/ViewList';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Cancel as CancelIcon } from '@mui/icons-material';
import Page from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import clientAdminServices from '../../../services/clientAdmin/course/clientAdminServices';
import CardSkeleton from '../../../components/Skeleton/cardSkeleton';


export default function Index() {
    const classes = useStyles();
    const navigate = useNavigate();
    const [assessments, setAssessments] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleCardClickItem = (data) => {
        navigate('/app/client-assessment-content', { state: data });
    };

    const getUser = async () => {
        try {
            const response = await clientAdminServices.getAssessments();
            if (response.ok) {
                setAssessments(response.data);
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        getUser();
    }, []);

    console.log(assessments, "assessments");

    const ButtonGrp = () => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
            <IconButton>
                <Search fontSize="medium" style={{ color: '#BCBCBC' }} />
            </IconButton>
            <IconButton>
                <FilterAltIcon fontSize="medium" style={{ color: '#BCBCBC' }} />
            </IconButton>
            <IconButton>
                <GridOnIcon fontSize="medium" style={{ color: '#00B673' }} />
            </IconButton>
            <IconButton>
                <ViewListIcon fontSize="medium" style={{ color: '#BCBCBC' }} />
            </IconButton>
        </div>
    );

    return (
        <div>
            <Page title="Assessment-list">
                <PageHeader pageTitle="Assessments " breadcrumbs={<ButtonGrp />} />
                <Container maxWidth={false} sx={{ padding: '0 !important' }}>
                    <Grid container spacing={2}>
                        {loading ? (
                            <>
                                {[1, 2, 3, 4, 5, 6].map(() => (
                                    <Grid item xs={12} sm={4} md={4}>
                                        <CardSkeleton />
                                    </Grid>
                                ))}
                            </>
                        ) : (
                            <>
                                <Grid container spacing={3}>
                                    {assessments.map((assessment) => (
                                        <Grid item xs={12} sm={6} md={4} key={assessment.id}>
                                            <Card
                                                sx={{
                                                    height: "100%",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    borderRadius: 3,
                                                    boxShadow: 3,
                                                    cursor: "pointer",
                                                    transition: "transform 0.2s ease",
                                                    "&:hover": {
                                                        transform: "translateY(-4px)",
                                                    },
                                                }}
                                                onClick={() => handleCardClickItem(assessment)}
                                            >

                                                {assessment.image_name && assessment.image_name !== "null" ? (
                                                    <CardMedia
                                                        component="img"
                                                        image={assessment.image_name}
                                                        alt={assessment.title}
                                                        sx={{
                                                            height: 220,
                                                            objectFit: "cover",
                                                            flexShrink: 0,
                                                        }}
                                                    />
                                                ) : (
                                                    <Box className="relative w-full h-[140px] sm:h-[160px] bg-gradient-to-br from-purple-600 to-purple-700 cursor-pointer flex items-center justify-center overflow-hidden group flex-shrink-0"
                                                        sx={{
                                                            height: 220,
                                                            backgroundColor: "#f5f5f5",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            color: "#888",
                                                            flexShrink: 0,
                                                        }}
                                                    >
                                                        <svg className="w-12 h-12 sm:w-14 sm:h-14 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                                                        </svg>
                                                    </Box>
                                                )}

                                                {/* CONTENT */}
                                                <CardContent
                                                    sx={{
                                                        flexGrow: 1,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                    }}
                                                >
                                                    <Typography variant="h6" fontWeight={600}>
                                                        {assessment.title}
                                                    </Typography>

                                                    {/* CHIPS */}
                                                    <Stack direction="row" spacing={1} sx={{ my: 1 }}>
                                                        <Chip label={assessment.type} size="small" />

                                                        <Chip
                                                            label={
                                                                assessment.status_type === 1
                                                                    ? "Published"
                                                                    : assessment.status_type === 4
                                                                        ? "Maintenance"
                                                                        : "Unpublished"
                                                            }
                                                            color={
                                                                assessment.status_type === 1
                                                                    ? "success"
                                                                    : assessment.status_type === 4
                                                                        ? "warning"
                                                                        : "error"
                                                            }
                                                            icon={
                                                                assessment.status_type === 1 ? (
                                                                    <CheckCircleIcon />
                                                                ) : assessment.status_type === 4 ? null : (
                                                                    <CancelIcon />
                                                                )
                                                            }
                                                            size="small"
                                                        />
                                                    </Stack>

                                                    {/* DESCRIPTION (CLAMPED) */}
                                                    <Box
                                                        sx={{
                                                            fontSize: 14,
                                                            color: "#444",
                                                            display: "-webkit-box",
                                                            WebkitLineClamp: 3,
                                                            WebkitBoxOrient: "vertical",
                                                            overflow: "hidden",
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: assessment.short_description,
                                                        }}
                                                    />

                                                    {/* FOOTER */}
                                                    <Box sx={{ mt: "auto", pt: 1 }}>
                                                        <Typography variant="body2" color="text.secondary">
                                                            Enrolled Users: {assessment.enrolledUsers}
                                                        </Typography>
                                                        <Typography variant="body2" color="text.secondary">
                                                            Licenses Allocated: {assessment.noOfLicenseAllocated}
                                                        </Typography>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>

                                {assessments.length === 0 && (
                                    <Typography marginTop={4} variant="h6" textAlign="center" sx={{ width: '100%' }}>
                                        No Data
                                    </Typography>
                                )}
                            </>
                        )}
                    </Grid>
                </Container>
            </Page>
        </div>
    );
}

const useStyles = makeStyles(() => ({
    cardHover: {
        // transition: 'all .5s ease-out',
        '&:hover': {
            // boxShadow: '0 12px 20px 0 rgb(32 40 45 / 8%)',
            transition: 'transform .5s',
            // transform: 'translateY(-5px)',
        },
    },
}));
